import React from 'react';
import './Banner.css';

export default function Banner() {
  return (
    <div className="banner-section">
      <h1 className="store">React Store</h1>
      <p className="banner-script">Helping you sell your products with fast and responsive sites.</p>
      </div>
  )
}
